export const blacklist: string[] = [
  'width',
  'hash',
  'height',
  'display',
  'display',
  'dup',
  'fieldname',
  'formname',
  'fromticket',
  'id',
  'iframe',
  'includeunderlying',
  'messageid',
  'msid',
  'options',
  'order',
  'orderaction',
  'p',
  'p/asx20',
  'page',
  'pages',
  'pt',
  'returnurltext',
  'sc',
  'sd',
  'section',
  'sector',
  'selectedstrategy',
  'sort',
  'sql',
  'src',
  'startpage',
  'storyid',
  'strike',
  't',
  'tab',
  'target',
  'volatility'
];

const attributeRename: any = {
  title: 'Title',
  tracker: 'Tracker',
  underlying: 'Underlying',
  underlyingcode: 'UnderlyingCode',
  seed: 'Seed',
  stockcode: 'StockCode',
  selectedaccountnumber: 'SelectedAccountNumber',
  gics: 'Gics',
  mode: 'Mode',
  level: 'Level',
  historicalvolatility: 'HistoricalVolatility',
  filter: 'Filter',
  exchange: 'Exchange',
  expiry: 'Expiry',
  dividendYield: 'DividendYield',
  url: 'Url',
  path: 'Path',
  view: 'View',
  referrer: 'Referrer',
  _ga: 'Ga',
  _gac: 'Gac',
  asxcode: 'Asxcode',
  side: 'as is',
  stock: 'Instrument',
  price: 'Price',
  returnurl: 'ReturnURL'
};

export const validateAttributeAndRename = (input: string): any => {
  const key = input.replace(/\?/g, '').trim(); // attribute may have ? in query string
  const keyword = key.toLowerCase();

  if (attributeRename[keyword]) {
    return attributeRename[keyword];
  }

  return blacklist.includes(keyword) ? undefined : key.charAt(0).toUpperCase() + key.slice(1);
};
